













































































































import {Vue, Component, Mixins} from 'vue-property-decorator';
import {Logo} from '@/components/Logo';
import {mapGetters, mapActions} from 'vuex';
import UserIcon from './UserIcon';
import { Navigation } from '@/types';
import HeaderMixins from '@/core/headerMixins';

@Component({
  name: 'AppHeader',
  components: {
    Logo,
    UserIcon,
  },
  mixins: [HeaderMixins],
  created() {
    document.addEventListener('click', this.clickOnPage);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.clickOnPage);
  },
  data() {
    return {
      linkAtHeader: ['about', 'toRenters', 'toBusiness', 'news'],
      possibleLangs: ['en', 'uk', 'ru'],
      showLangPanel: false,
      openMobMenu: false,
      loginLink: '',
    };
  },
  computed: {
    ...mapGetters([
      'navigation',
      'language',
      'mobMenuLangText',
      'translations',
    ]),
    ...mapGetters('user', ['logged']),
    displayedLanguage() {
      return this.possibleLangs.filter((item) => item !== this.language);
    },
    langBlock() {
      return document.getElementById('lang-block');
    },
    loginName() {
      const route: Navigation = this.navigation.flatMap((item) => {
          return !!item.children ? [...item.children, item] : [item];
      })
      .filter((item: Navigation) => {
        return item.name === 'login';
      })[0];
      this.loginLink = route.name ?? 'login';
      return route.meta?.link_name ?? route.name;
    },
  },
  methods: {
    ...mapActions(['setUserLanguage']),
    ...mapActions('user', ['logout']),
    actualLink(name) {
      return this.linkAtHeader.indexOf(name) !== -1;
    },
    changeLanguage(lang, type) {
      this.setUserLanguage(lang);
      if (type) {
        this.toggleMenu();
      }
    },
    goTo(path: string): void {
      this.$router.push(path);
    },
    goToMob(path: string): void {
      this.$router.push({name: path});
      this.toggleMenu();
    },
    clickOnPage(e) {
      if (this.showLangPanel && !this.langBlock.contains(e.target)) {
        this.showLangPanel = !this.showLangPanel;
      }
    },
    toggleMenu() {
      this.openMobMenu = !this.openMobMenu;
      const appBlock = document.getElementById('app');
      if (this.openMobMenu && appBlock) {
        appBlock.classList.add('hideScroll');
      } else if (!this.openMobMenu && appBlock) {
        appBlock.classList.remove('hideScroll');
      }
    },
    logoutUser() {
      this.logout();
      this.toggleMenu();
      const { href } = this.$router.resolve({name: this.$route.name || ''});
      location.href = href;
    },
    resolvePermission(link) {
      return link?.meta?.hasPermission ?? true;
    },
  },
})
export default class AppHeader extends Vue {
}
